import { Stack, Typography } from "@mui/material";
import { ConditionalRenderer } from "../conditionalRenderer";
import { useLanguageTranslator } from "../useLanguageContext";

function DataDisplayMessage({ loading, data }: any) {
  const { translator } = useLanguageTranslator();
  return (
    <>
      <ConditionalRenderer condition={loading && data?.length <= 0}>
        <Stack direction="row" justifyContent="center" width={"100%"} my={10}>
          <Typography variant="h3" textAlign={"center"}>
            {translator("Loading data")}...
          </Typography>
        </Stack>
      </ConditionalRenderer>
      <ConditionalRenderer condition={!loading && data?.length <= 0}>
        <Stack direction="row" justifyContent="center" width={"100%"} my={10}>
          <Typography variant="h3" textAlign={"center"}>
            {translator("No data available for applied filters")}
          </Typography>
        </Stack>
      </ConditionalRenderer>
    </>
  );
}

export { DataDisplayMessage };
